<div class="modal-header">
  <h4 class="modal-title" id="modal-title">You are about get logged out</h4>
</div>
<input type="hidden" ngbAutofocus>
<div class="modal-footer">
  <button type="button" class="btn btn-default" (click)="refreshToken()">Refresh</button>
  <button type="button" class="btn btn-primary" (click)="loginClick()">Login</button>
</div>
